import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { ContentNode } from './content-node.model';

export class ContentNodeStateModel extends EntityStateModel<ContentNode> {}
